<template>
  <div id="app">
    <div v-if="$auth().loggedIn()" id="offcanvas-usage" uk-offcanvas="flip: true; overlay: true">
      <div class="uk-offcanvas-bar">
        <button class="uk-offcanvas-close" type="button" uk-close></button>
        <ul class="uk-nav uk-nav-default">
          <li><router-link :to="{ name: 'Home' }"><i class="fas fa-square-full"></i>  Home</router-link></li>
          <li><router-link :to="{ name: 'Product' }"><i class="fas fa-square-full"></i>  Products</router-link></li>
          <li><router-link :to="{ name: 'Item' }"><i class="fas fa-square-full"></i> Items</router-link></li>
          <li><router-link :to="{ name: 'User' }"><i class="fas fa-square-full"></i> Users</router-link></li>
        </ul>
      </div>
    </div>
    <header v-if="$auth().loggedIn()">
      <div class="uk-container">
        <nav class="uk-navbar uk-navbar-container" uk-navbar>
          <div class="uk-navbar-left">
            <a class="uk-navbar-toggle uk-hidden@s" href="#offcanvas-usage" uk-toggle>
              <span uk-navbar-toggle-icon></span> <span class="uk-margin-small-left">Menu</span>
            </a>
              <ul class="uk-navbar-nav">
                <li><router-link :to="{ name: 'Home' }"><i class="fas fa-square-full"></i> <span>Home</span></router-link></li>
                <li><router-link :to="{ name: 'Product' }"><i class="fas fa-square-full"></i> <span>Products</span></router-link></li>
                <li><router-link :to="{ name: 'Item' }"><i class="fas fa-square-full"></i> <span>Items</span></router-link></li>
                <li><router-link :to="{ name: 'User' }"><i class="fas fa-square-full"></i> <span>Users</span></router-link></li>
              </ul>
          </div>
          <div class="uk-navbar-right uk-visible@s">
            <ul class="uk-navbar-nav">
              <li><a href="#" v-on:click.prevent="$auth().logout()"><i class="fas fa-sign-out-alt"></i> <span>Logout</span></a></li>
            </ul>
          </div>
        </nav>
      </div>
    </header>
    <div class="uk-container">
      <div>
        <div v-if="$auth().loggedIn()" class="uk-width-1-1 uk-text-right">
          <router-link
            v-if="$routerHistory.hasPrevious()"
            :to="{ path: $routerHistory.previous().path }"
            class="uk-button uk-button-small back-button">
            <i class="fas fa-arrow-left"></i> back
          </router-link>
        </div>
        <transition name="fade" mode="out-in" :duration="250">
          <router-view/>
        </transition>
      </div>
    </div>

    <footer class="uk-position-fixed uk-light uk-position-bottom uk-text-center">
      <p>
        Commodity 2018
      </p>
    </footer>
  </div>
</template>

<script>
import '@/assets/global.css'
export default {
  name: 'App',
  mounted() {
    const self = this;

    self.$request().get('/status').then(r => {
      r = self.$request().successHandler(r).data;

      if (!r.installation) {
        self.$router.push({name: 'Install'});
      }
    })
  }
}
</script>

<style>
  html, body{
    width: 100%;
    height: 100%;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
  #app{
    margin-bottom: 40px;
  }
  header {
    background: #34495e;
  }
  header .uk-navbar-container:not(.uk-navbar-transparent){
    background: #34495e;
  }
  .uk-navbar-nav > li > a{
    font-weight: 600!important;
    color: #fff!important;
  }
  .uk-navbar-nav > li > a > svg{
    font-size: 6px!important;
  }
  .uk-navbar-nav > li > a:hover, .uk-navbar-nav > li.active > a, .uk-navbar-nav > li > a:focus{
    color: #fff!important;
  }
  .uk-navbar-nav > li > a, .uk-navbar-toggle{
    min-height: 60px!important;
  }
  .uk-navbar-nav > li > a > span{
    margin-left: 5px;
  }
  .fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }
  .uk-offcanvas-close {
    right: 20px;
    left: initial;
  }
  .title-tools select, .title-tools a, .title-tools span{
    font-size: 12px!important;
    color: #333;
  }
  .back-button{
    background: #34495e;
    color: #fff;
  }
  .back-button:hover, .back-button:focus{
    color: #fff;
  }
  footer{
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    padding: 10px 0;
    background: #34495e;
  }
  footer p{
    font-size: 13px;
    margin: 0;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue